import RecurringOrderCard from 'components/orders/RecurringOrderCard/styled';

export default RecurringOrderCard;
